import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const NavLibraryIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M9.82 1.25H3C2.04 1.25 1.25 2.04 1.25 3V9.82C1.25 10.51 1.81 11.07 2.5 11.07H9.82C10.51 11.07 11.07 10.51 11.07 9.82V2.5C11.07 1.81 10.51 1.25 9.82 1.25ZM9.57 9.57H2.75V3C2.75 2.86 2.86 2.75 3 2.75H9.57V9.57Z"
        fill={color}
      />
      <path
        d="M21.0001 1.25H14.1801C13.4901 1.25 12.9301 1.81 12.9301 2.5V9.82C12.9301 10.51 13.4901 11.07 14.1801 11.07H21.5001C22.1901 11.07 22.7501 10.51 22.7501 9.82V3C22.7501 2.04 21.9601 1.25 21.0001 1.25ZM21.2501 9.57H14.4301V2.75H21.0001C21.1401 2.75 21.2501 2.86 21.2501 3V9.57Z"
        fill={color}
      />
      <path
        d="M9.82 12.93H2.5C1.81 12.93 1.25 13.49 1.25 14.18V21C1.25 21.96 2.04 22.75 3 22.75H9.82C10.51 22.75 11.07 22.19 11.07 21.5V14.18C11.07 13.49 10.51 12.93 9.82 12.93ZM9.57 21.25H3C2.86 21.25 2.75 21.14 2.75 21V14.43H9.57V21.25Z"
        fill={color}
      />
      <path
        d="M21.5001 12.93H14.1801C13.4901 12.93 12.9301 13.49 12.9301 14.18V21.5C12.9301 22.19 13.4901 22.75 14.1801 22.75H21.0001C21.9601 22.75 22.7501 21.96 22.7501 21V14.18C22.7501 13.49 22.1901 12.93 21.5001 12.93ZM21.2501 21C21.2501 21.14 21.1401 21.25 21.0001 21.25H14.4301V14.43H21.2501V21Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

NavLibraryIcon.displayName = 'NavLibraryIcon';
